























import { Component, Mixins } from "vue-property-decorator";
import { ISourcePrintable } from "..";
import { DialogMixin, SourcePrintableMixin } from "../mixins";

@Component({
})
export default class StandardPdfPrinter extends Mixins(SourcePrintableMixin, DialogMixin) implements ISourcePrintable {
  data(): any {
    return {
      isDialogVisible: false,
    };
  }
  isDialogVisible: boolean;

  printSource(source: string, copies: number, shouldSelectPrinter: boolean) {
    // 部数と出力先はブラウザ任せなので無視.
    if (source === "") {
      return;
    }
    this.sourceToPrint = null;  // v-ifで1度objectをDOMから削除を促す
    this.$nextTick(() => {
      this.isDialogVisible = true;
      this.sourceToPrint = source + "#view=Fit";
    });
  }
}
